import MemoList from "../MemoList";

export default function Commissioner() {
  return <MemoList memoType="Commissioner" />;
}
